'use client'

import { FC, useEffect, useRef, useState } from 'react'
import CarouselCard, { CarouselVideoItem } from './CarouselCard'
import VideoCarouselOverlayStyles from './VideoCarouselOverlayStyles'

export interface VideoCarouselOverlayProps {
  /** 一覧に出す動画（再生中の動画は呼び出し側で除いておく） */
  videos: CarouselVideoItem[]
  onVideoSelect: (videoId: string) => void
  onClose: () => void
}

/**
 * SP「別の動画へ」で下からせり上がるサムネイル一覧。
 * 位置は `position: absolute; bottom: 0`（.carousel-overlay）なので、
 * 画面固定のシェル（埋め込みの .sp-modal／動画個別ページの fixed inset-0）直下に置く。
 */
const VideoCarouselOverlay: FC<VideoCarouselOverlayProps> = ({ videos, onVideoSelect, onClose }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)

  // Trigger slide-up animation on mount
  useEffect(() => {
    requestAnimationFrame(() => {
      setIsVisible(true)
    })
  }, [])

  // Handle close with slide-down animation
  const handleClose = () => {
    setIsVisible(false)
    setTimeout(onClose, 300)
  }

  // Handle video selection
  const handleVideoSelect = (videoId: string) => {
    setIsVisible(false)
    setTimeout(() => {
      onVideoSelect(videoId)
      onClose()
    }, 300)
  }

  return (
    <>
      <VideoCarouselOverlayStyles />

      {/* Backdrop */}
      <div className={`carousel-backdrop ${isVisible ? 'visible' : ''}`} />

      {/* Carousel Panel */}
      <div className={`carousel-overlay ${isVisible ? 'visible' : ''}`}>
        {/* Close Handle */}
        <button type="button" className="carousel-close-button" onClick={handleClose}>
          <svg className="carousel-close-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9L12 15L18 9" stroke="rgba(255,255,255,0.6)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        {/* Scrollable Cards */}
        <div ref={scrollContainerRef} className="carousel-scroll-container">
          <div className="carousel-items">
            {videos.map((item) => (
              <CarouselCard key={item.id} item={item} onSelect={() => handleVideoSelect(item.id)} />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default VideoCarouselOverlay
